import { getModuleLoadErrorAttributes } from './get-module-load-error-attributes';

// SAIN uses the existing networkErrorReason value for every recognized module-load failure.
export const getModuleFetchErrorAttributes = (
	error: Error,
): { networkErrorReason?: string; errorCode?: number } => {
	const { moduleLoadFailure, errorCode } = getModuleLoadErrorAttributes(error);
	return moduleLoadFailure
		? { networkErrorReason: 'browser_network_error', ...(errorCode !== undefined && { errorCode }) }
		: {};
};
